<template>
  <BaseFrame :infos='infos' :idText='idText' @save='isSubmit=false; submit()'
  @submit='isSubmit=true; submit()' @clear='clearModal=true'
  :saveText='supplierForm.flowStatus===1|| $route.name==="supplierStoreAdd"?"保存":""'
  submitText='提交' :infosArr='titleInfo' :id='id+""'
  :logText="$route.name!=='supplierStoreAdd'?'操作日志':''" :logData='records' @hanldeLog='getRecord'
  :saveLoading='saveLoading' :submitLoading='submitLoading'
  :printText='printText' @print='handlePrint'>
      <lk-form slot='content' :model='supplierForm'
        :label-width='160' label-position="right" ref="supplierForm">
        <!-- <ApprovalFlow :workNo="workNo" class="steps-wrap" :finishHide="true"/> -->
        <StoreSupplier v-model="supplierForm"
          v-if="baseSupplierShow"
          @onNameChanged='onNameChanged'
          :able='able'
          :scopeLists='scopeLists'

          :isInStore='true'
          ref='supplierInfo'>
        </StoreSupplier>

        <DTPModal v-model="clearModal" content='重置将取消当前所做更改。' @confirm='reset' type='alert'>
        </DTPModal>
        <LinkQR005 ref="LinkQR005"/>
      </lk-form>
  </BaseFrame>
</template>
<script>
import BaseFrame from '../../../components/frame/BaseFrame.vue';
import utils from '../../../libs/utils';
import supplier from '../../../services/supplier';
import DTPModal from '../../../components/DTPModal.vue';
import permission from '../../../mixins/permission'; // 鉴权
// import mapState from '../../../mixins/mapState'; // 鉴权
import StoreSupplier from '../../../components/supplier';
// import ApprovalFlow from '../../../components/ApprovalFlow';
// import permission from '../../../mixins/permission'; // 鉴权
import LinkQR005 from '../../../components/print/LinkQR005';

export default {
  name: 'SupplierStoreEdit',
  mixins: [permission],
  components: {
    BaseFrame,
    DTPModal,
    StoreSupplier,
    // ApprovalFlow,
    LinkQR005,
  },
  watch: {
    $route() {
      this.init();
    },
  },
  data() {
    return {
      printText: '',
      // workNo: 'goods1102933126',
      baseSupplierShow: false,
      able: false,
      records: [],
      saveLoading: false,
      submitLoading: false,
      isSubmit: false,
      id: '',
      titleInfo: [],
      clearModal: false,
      idText: '',
      infos: null,
      supplierForm: {
        id: '', // 主键
        memoryCode: '', // 助记码
        code: '', // 供应商编码
        name: '', // 供应商名称
        status: '', // 单据状态（1:启用；2:禁用；3:删除）
        rigistryFund: '', // 注册资金
        area: '', // 区域
        postCode: '', // 邮编
        qualityResponsible: '', // 质量负责人
        enterpriseType: [], // 企业类型
        corporationPerson: '', // 企业法人
        rigistryAddress: '', // 注册地址
        socialUnifyCreditCode: '', // 社会统一信用代码
        businessLicenceUrl: '', // 营业执照url
        businessLicenceRange: [],
        businessLicenceDate: '', // 营业执照发证日期 +
        businessLicenceEffecivePeroid: '', // 营业执照有效日期 +
        businessLicenceOffice: '', // 营业执照发证机关 +
        businessLicenceForever: false, // 营业执照永久 +

        drugProdScopeIds: '', // 药品生产范围
        drugProductCredentailCode: '', // 药品生产许可证号
        drugProductCredentailUrl: '', // 药品生产许可证证件照url
        drugProductRange: [], // 药品生产期限
        drugProductDate: '', // 药品生产许可证发证日期
        drugProductEffecivePeroid: '', // 药品生产许可证有效期限
        drugProductOffice: '', // 药品生产许可证发证机关
        gmpCode: '',
        gmpUrl: '', // gmp证书证件照url
        gmpRange: [], // gmp证书证件
        gmpCredentailDate: '', // gmp证书发证日期
        gmpEffecivePeroid: '', // gmp证书有效期限
        gmpCredentailOffice: '', // gmp证书发证机关

        drugBizScopeIds: '', // 药品经营范围
        drugBusinessCredentailUrl: '', // 药品经营许可证证件照url
        drugBusinessCredentailCode: '',
        drugBusinessRange: [], // 药品经营许可证证件照url
        drugBusinessEffecivePeroid: '', // 药品经营许可证有效期限
        drugBusinessOffice: '', // 药品经营许可证发证机关
        drugBusinessDate: '', // 药品经营许可证发证日期
        gspUrl: '', // gsp证书证件照url
        gspCode: '',
        gspRange: [], // gsp证书证件
        gspCredentailOffice: '', // gsp证书发证机关
        gspCredentailDate: '', // gsp证书发证日期
        gspEffecivePeroid: '', // gsp证书有效期限

        equipmentProdScopeIds: '',
        equipmentProdUrl: '',
        equipmentProdCode: '',
        equipmentProdRange: [],
        equipmentProdDate: '',
        equipmentProdExpiry: '',
        equipmentProdOffice: '',

        equipmentBizScopeIds: '',
        secondMediEquiCode: '', // 二类医疗器械生产（经营）企业许可证号
        secondMediEquiUrl: '', // 二类医疗器械生产（经营）企业许可证证件照url
        secondMediEquiCredOffice: '', // 二类医疗器械生产（经营）许可证发证机关
        secondMediEquiCredDate: null, // 二类医疗器械生产（经营）许可证发证日期

        thirdMediEquiCode: '', // 三类医疗器械生产（经营）企业许可证号
        thirdMediEquiUrl: '', // 三类医疗器械生产（经营）企业许可证证件照url
        thirdMediEquiRange: [], // 三类医疗器械生产（经营）企业许可证证件照url
        thirdMediEquiEffecPeroid: '', // 三类医疗器械生产（经营）许可证有效期限
        thirdMediEquiCredOffice: '', // 三类医疗器械生产（经营）许可证发证机关
        thirdMediEquiCredDate: '', // 三类医疗器械生产（经营）许可证发证日期

        foodCredentailCode: '', // 食品生产许可证号
        foodCredentailUrl: '', // 食品生产许可证证件照url
        foodCredentailRange: [], // 食品生产许可证证件照url
        foodEffecivePeroid: '', // 食品生产许可证有效期限
        foodCredentialOffice: '', // 食品生产许可证发证机关
        foodCredentailDate: '', // 食品生产许可证发证日期

        foodBizUrl: '',
        foodBizExpiry: '',
        foodBizOffice: '',
        foodBizDate: '',
        foodBizCode: '',
        foodBizRange: [],

        cosmeticCredentailUrl: '', // 化妆品生产企业卫生许可证证件照url
        cosmeticCredentailCode: '', // 化妆品生产企业卫生许可证号
        cosmeticCredentailOffice: '', // 化妆品生产企业卫生许可证发证机关
        cosmeticCredentailRange: [],
        cosmeticCredentailDate: '',
        cosmeticCredentailPeroid: '',

        otherCredentailUrl: '', // 其他证件证件照url
        otherCredentailCode: '', // 其他证件证件证号
        otherCredentailOffice: '', // 其他证件证件发证机关
        otherCredentailRange: [],
        otherCredentailDate: '',
        otherCredentailPeroid: '',

        otherLicense2Url: '',
        otherLicense2Code: '',
        otherLicense2Office: '',
        otherLicense2Range: [],
        otherLicense2Date: '',
        otherLicense2Expiry: '',

        depositBank: '', // 开户行
        repositoryAddress: '', // 仓库地址
        bankAccount: '', // 银行账号
        qualityEnsureProtocolCode: '', // 质量保证协议编号
        qualityEnsureProtocolUrl: '', // 质量保证协议url
        qualityEnsureEffecivePeroid: '', // 质量协议有效期限
        authorizerName: '', // 授权人姓名
        authorizerEffecivePeroid: '', // 授权书有效期至
        depositaryName: '', // 受托人姓名
        depositaryIdCard: '', // 受托人身份证号
        depositaryIdEffecivePeroid: '', // 受托人身份证有效期限
        followGoodBillCode: '', // 随货通行单单据号
        followGoodBillUrl: '', // 随货通行单单据照url
        stampCode: '', // 印章印模编号
        stampUrl: '', // 印章印模url
        filedDocCode: '', // 文件归档编号
        filedDocState: '', // 业务员备案情况
        filedDocEffecivePeroid: '', // 备案有效期
        qualitiedSupplierTable: '', // 合格供应商档案表
        puchasePersonSuggestion: '', // 采购员意见
        storeId: '',
        storeName: '',
        createUserId: '',
        createUserName: '',
        createTime: '',
        refOriginId: '',
        accountProid: '',
        payWay: '',
        creditLimit: '',
        authorizerBookUrl: '',
      },
      scopeLists: {
        drugProdLabelList: [],
        drugBizLabelList: [],
        equipmentProdLabelList: [],
        equipmentBizLabelList: [],
      },
    };
  },
  methods: {
    handlePrint() {
      this.$refs.LinkQR005.handlePrint(this.$route.params.id);
    },
    reset() {
      if (this.$route.name !== 'supplierStoreAdd') {
        this.supplierForm = { enterpriseType: [] };
        this.getInfos().then(() => {
          this.$store.commit('setLeaveModal', false);
        });
      } else {
        console.log(this.$refs);
        this.$refs.supplierInfo.confirmClear();
      }
      this.clearModal = false;
      this.$nextTick(() => {
        this.$store.commit('setLeaveModal', false);
      });
    },


    clearAll() {
      this.clearModal = true;
    },
    getRecord() {
      supplier.getRecord({ originType: 2, refOriginId: this.$route.params.id }).then((res) => {
        if (res.data.status === 200) {
          // this.record
          this.records = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    onNameChanged(name) {
      if (name) {
        this.$store.commit('setDisableLoading', true);
        supplier.mnemonicCode({ name }).then((res) => {
          if (res.data.status === 200) {
            this.supplierForm.memoryCode = res.data.data;
          }
        });
      } else {
        this.supplierForm.memoryCode = '';
      }
    },
    getTitleInfo() {
      return new Promise((resolve) => {
        supplier.supplierInfo({ originType: 2, id: this.$route.params.id }).then((res) => {
          if (res.data.status === 200) {
            const { data } = res.data;
            this.idText = '供应商编码';
            this.id = data.code || '';
            this.titleInfo = [
              { name: '供应商名称:', value: data.supplierName },
              { name: '创建人:', value: data.createUserName },
              { name: '创建时间:', value: data.createTime ? utils.exchangeTimeToSecond(data.createTime) : '' },
              { name: '最后修改人:', value: data.lastModifiedUserName },
              { name: '最后修改时间:', value: data.lastMmodifiedTime ? utils.exchangeTimeToSecond(data.lastMmodifiedTime) : '' },
            ];
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    submit() {
      const temp = utils.deepClone(this.supplierForm);
      const validate = true;
      temp.businessLicenceDate = temp.businessLicenceRange[0];
      temp.businessLicenceEffecivePeroid = temp.businessLicenceRange[1];

      temp.gspCredentailDate = temp.gspRange[0];
      temp.gspEffecivePeroid = temp.gspRange[1];

      temp.gmpCredentailDate = temp.gmpRange[0];
      temp.gmpEffecivePeroid = temp.gmpRange[1];

      temp.drugProductDate = temp.drugProductRange[0];
      temp.drugProductEffecivePeroid = temp.drugProductRange[1];

      temp.drugBusinessDate = temp.drugBusinessRange[0];
      temp.drugBusinessEffecivePeroid = temp.drugBusinessRange[1];

      temp.equipmentProdDate = temp.equipmentProdRange[0];
      temp.equipmentProdExpiry = temp.equipmentProdRange[1];

      temp.thirdMediEquiCredDate = temp.thirdMediEquiRange[0];
      temp.thirdMediEquiEffecPeroid = temp.thirdMediEquiRange[1];

      temp.foodCredentailDate = temp.foodCredentailRange[0];
      temp.foodEffecivePeroid = temp.foodCredentailRange[1];

      temp.foodBizDate = temp.foodBizRange[0];
      temp.foodBizExpiry = temp.foodBizRange[1];

      temp.cosmeticCredentailDate = temp.cosmeticCredentailRange[0];
      temp.cosmeticCredentailPeroid = temp.cosmeticCredentailRange[1];

      temp.otherCredentailDate = temp.otherCredentailRange[0];
      temp.otherCredentailPeroid = temp.otherCredentailRange[1];

      temp.otherLicense2Date = temp.otherLicense2Range[0];
      temp.otherLicense2Expiry = temp.otherLicense2Range[1];
      // if (temp.secondMediEquiCredDate) {
      //   temp.secondMediEquiCredDate = (new Date(temp.secondMediEquiCredDate)).getTime();
      // }

      if (temp.enterpriseType) {
        temp.enterpriseType = temp.enterpriseType.join(',');
      }

      // if (!temp.enterpriseType.includes('1')) { // 剔除没有选择的企业类型的标签数据
      //   temp.drugBizScopeIds = [];
      // } else if (!temp.enterpriseType.includes('2')) {
      //   temp.drugProdScopeIds = [];
      // } else if (!temp.enterpriseType.includes('4')) {
      //   temp.equipmentProdScopeIds = [];
      // } else if (!temp.enterpriseType.includes('5')) {
      //   temp.equipmentBizScopeIds = [];
      // }
      if (!temp.enterpriseType.includes('2')) {
        temp.drugProdScopeIds = [];
        temp.drugProductCredentailUrl = '';
        temp.drugProductCredentailCode = '';
        temp.drugProductRange = [];
        temp.drugProductOffice = '';
        temp.gmpUrl = '';
        temp.gmpCode = '';
        temp.gmpRange = [];
        temp.gmpCredentailOffice = '';
      }
      if (!temp.enterpriseType.includes('1') && !temp.enterpriseType.includes('2')) { // 剔除没有选择的企业类型的标签数据
        temp.drugBizScopeIds = [];
      }
      if (!temp.enterpriseType.includes('1')) {
        temp.drugBusinessCredentailUrl = '';
        temp.drugBusinessCredentailCode = '';
        temp.drugBusinessRange = [];
        temp.drugBusinessOffice = '';
        temp.gspUrl = '';
        temp.gspCode = '';
        temp.gspRange = [];
        temp.gspCredentailOffice = '';
      }
      if (!temp.enterpriseType.includes('3')) {
        temp.foodCredentailUrl = '';
        temp.foodCredentailCode = '';
        temp.foodCredentailRange = [];
        temp.foodCredentialOffice = '';
        temp.foodBizUrl = '';
        temp.foodBizCode = '';
        temp.foodBizRange = [];
        temp.foodBizOffice = '';
      }
      if (!temp.enterpriseType.includes('4')) {
        temp.equipmentProdScopeIds = [];
        temp.equipmentProdUrl = '';
        temp.equipmentProdCode = '';
        temp.equipmentProdRange = [];
        temp.equipmentProdOffice = '';
      }
      if (!temp.enterpriseType.includes('5') && !temp.enterpriseType.includes('4')) {
        temp.equipmentBizScopeIds = [];
      }
      if (!temp.enterpriseType.includes('5')) {
        temp.secondMediEquiUrl = '';
        temp.secondMediEquiCode = '';
        temp.secondMediEquiCredDate = '';
        temp.secondMediEquiCredOffice = '';
        temp.thirdMediEquiUrl = '';
        temp.thirdMediEquiCode = '';
        temp.thirdMediEquiRange = [];
        temp.thirdMediEquiCredOffice = '';
      }
      if (!temp.enterpriseType.includes('6')) {
        temp.cosmeticCredentailUrl = '';
        temp.cosmeticCredentailCode = '';
        temp.cosmeticCredentailRange = [];
        temp.cosmeticCredentailOffice = '';
      }


      if (temp.drugProdScopeIds) {
        temp.drugProdScopeIds = temp.drugProdScopeIds.join(',');
      }
      if (temp.drugBizScopeIds) {
        temp.drugBizScopeIds = temp.drugBizScopeIds.join(',');
      }
      if (temp.equipmentProdScopeIds) {
        temp.equipmentProdScopeIds = temp.equipmentProdScopeIds.join(',');
      }
      if (temp.equipmentBizScopeIds) {
        temp.equipmentBizScopeIds = temp.equipmentBizScopeIds.join(',');
      }
      // for (const key in temp) {
      //   if (key.includes('createTime') || key.includes('Peroid') || key.includes('Date')) {
      //     if (temp[key]) {
      //       temp[key] = (new Date(temp[key])).getTime();
      //     }
      //   }
      // }
      // 保存流程
      if (!this.isSubmit && validate) {
        this.$refs.supplierInfo.validateForm('socialUnifyCreditCode').then((msg) => {
          if (msg) {
            if (temp.id) {
              this.saveLoading = true;
              // 更新流程
              supplier.SupplierStoreUpdate(temp).then((res) => {
                if (res.data.status === 200) {
                  this.$Message.success('提交成功');
                  this.$store.commit('setLeaveModal', false);
                  setTimeout(() => {
                    this.saveLoading = false;
                    this.$router.push({ name: 'supplierStore' });
                  }, 1000);
                } else {
                  this.saveLoading = false;
                  this.$Message.error(res.data.error);
                }
              }).catch((err) => {
                this.saveLoading = false;
                utils.handleError(err);
              });
            } else {
              this.saveLoading = true;
              // 新增流程
              supplier.SupplierStoreSave(temp).then((res) => {
                if (res.data.status === 200) {
                  this.$Message.success('保存成功');
                  this.$store.commit('setLeaveModal', false);
                  setTimeout(() => {
                    this.saveLoading = false;
                    this.$router.push({ name: 'supplierStore' });
                  }, 1000);
                } else {
                  this.saveLoading = false;
                  this.$Message.error(res.data.error);
                }
              }).catch((err) => {
                this.saveLoading = false;
                utils.handleError(err);
              });
            }
          } else {
            this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
          }
        });
        return;
      }
      // 供应商信息验证
      this.$refs.supplierInfo.validateSubmit().then((storeValidate) => {
        if (storeValidate) {
          if (this.isSubmit && validate) {
            this.isSubmit = false;
            this.submitLoading = true;
            supplier.SupplierStoreSubmit(temp).then((res) => {
              if (res.data.status === 200) {
                this.$Message.success('资料修改已提交，请在审批管理查看审批进度');
                this.$store.commit('setLeaveModal', false);
                setTimeout(() => {
                  this.submitLoading = false;
                  this.$router.push({ name: 'supplierStore' });
                }, 1000);
              } else {
                this.submitLoading = false;
                this.$Message.error(res.data.error);
              }
            }).catch((err) => {
              this.submitLoading = false;
              utils.handleError(err);
            });
          } else {
            this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
          }
        } else {
          this.$Message.error('缺少必填项或信息不符合要求，请检查后再提交');
        }
      });
    },
    getInfos(isFormAdd) {
      return new Promise((resolve) => {
        supplier.SupplierStoreInfos({ id: this.$route.params.id }).then((res) => {
          if (res.data.status === 200) {
            // this.supplierForm = {};
            const data = res.data.data.storeInfo;
            this.exchangeDateArr(data);
            // for (const key in data) {
            //   if (key.includes('createTime') || key.includes('Peroid') || key.includes('Date')) {
            //     if (key !== 'secondMediEquiCredDate') {
            //       data[key] = new Date(data[key]);
            //     }
            //   }
            // }
            data.enterpriseType = data.enterpriseType ? data.enterpriseType.split(',') : [];
            data.drugProdScopeIds = data.drugProdScopeIds ? data.drugProdScopeIds.split(',') : [];
            data.drugBizScopeIds = data.drugBizScopeIds ? data.drugBizScopeIds.split(',') : [];
            data.equipmentProdScopeIds = data.equipmentProdScopeIds ? data.equipmentProdScopeIds.split(',') : [];
            data.equipmentBizScopeIds = data.equipmentBizScopeIds ? data.equipmentBizScopeIds.split(',') : [];
            for (const key in data) {
              if (key.includes('Range')) {
                if (!data[key][0]) {
                  data[key] = [];
                }
              }
            }
            Object.assign(this.supplierForm, data);
            if (this.supplierForm.code && this.able) {
              this.editInfo = true;
            }
            if (this.$route.name === 'supplierStoreCheck') {
              this.groupCheck = null;
              this.firstFill = null;
              if (isFormAdd) {
                this.$refs.supplierInfo && this.$refs.supplierInfo.validateSubmit();
              }
            }
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    exchangeDateArr(data) {
      data.businessLicenceRange = [];
      data.drugProductRange = [];
      data.gmpRange = [];
      data.drugBusinessRange = [];
      data.gspRange = [];
      data.equipmentProdRange = [];
      data.thirdMediEquiRange = [];
      data.foodCredentailRange = [];
      data.foodBizRange = [];
      data.cosmeticCredentailRange = [];
      data.otherCredentailRange = [];
      data.otherLicense2Range = [];
      if (data.businessLicenceEffecivePeroid) {
        data.businessLicenceRange[0] = data.businessLicenceDate; // ? new Date(data.businessLicenceDate) : '';
        data.businessLicenceRange[1] = data.businessLicenceEffecivePeroid; // ? new Date(data.businessLicenceEffecivePeroid) : '';
      }
      if (data.drugProductEffecivePeroid) {
        data.drugProductRange[0] = data.drugProductDate; // ? new Date(data.businessLicenceDate) : '';
        data.drugProductRange[1] = data.drugProductEffecivePeroid; // ? new Date(data.businessLicenceEffecivePeroid) : '';
      }
      if (data.gmpEffecivePeroid) {
        data.gmpRange[0] = data.gmpCredentailDate; // ? new Date(data.gmpCredentailDate) : '';
        data.gmpRange[1] = data.gmpEffecivePeroid; // ? new Date(data.gmpEffecivePeroid) : '';
      }
      if (data.drugBusinessEffecivePeroid) {
        data.drugBusinessRange[0] = data.drugBusinessDate; // ? new Date(data.drugBusinessDate) : '';
        data.drugBusinessRange[1] = data.drugBusinessEffecivePeroid; // ? new Date(data.drugBusinessEffecivePeroid) : '';
      }
      if (data.gspEffecivePeroid) {
        data.gspRange[0] = data.gspCredentailDate; // ? new Date(data.gspCredentailDate) : '';
        data.gspRange[1] = data.gspEffecivePeroid; // ? new Date(data.gspEffecivePeroid) : '';
      }
      if (data.equipmentProdExpiry) {
        data.equipmentProdRange[0] = data.equipmentProdDate; // ? new Date(data.gspCredentailDate) : '';
        data.equipmentProdRange[1] = data.equipmentProdExpiry; // ? new Date(data.gspEffecivePeroid) : '';
      }
      // if (data.secondMediEquiCredDate) {
      //   data.secondMediEquiCredDate = new Date(data.secondMediEquiCredDate);
      // }
      if (data.thirdMediEquiEffecPeroid) {
        data.thirdMediEquiRange[0] = data.thirdMediEquiCredDate; // ? new Date(data.thirdMediEquiCredDate) : '';
        data.thirdMediEquiRange[1] = data.thirdMediEquiEffecPeroid; // ? new Date(data.thirdMediEquiEffecPeroid) : '';
      }
      if (data.foodEffecivePeroid) {
        data.foodCredentailRange[0] = data.foodCredentailDate; // ? new Date(data.foodCredentailDate) : '';
        data.foodCredentailRange[1] = data.foodEffecivePeroid; // ? new Date(data.foodEffecivePeroid) : '';
      }
      if (data.foodBizExpiry) {
        data.foodBizRange[0] = data.foodBizDate; // ? new Date(data.foodCredentailDate) : '';
        data.foodBizRange[1] = data.foodBizExpiry; // ? new Date(data.foodEffecivePeroid) : '';
      }
      if (data.cosmeticCredentailPeroid) {
        data.cosmeticCredentailRange[0] = data.cosmeticCredentailDate; // ? new Date(data.cosmeticCredentailDate) : '';
        data.cosmeticCredentailRange[1] = data.cosmeticCredentailPeroid; // ? new Date(data.cosmeticCredentailPeroid) : '';
      }
      if (data.otherCredentailPeroid) {
        data.otherCredentailRange[0] = data.otherCredentailDate; // ? new Date(data.otherCredentailDate) : '';
        data.otherCredentailRange[1] = data.otherCredentailPeroid; // ? new Date(data.otherCredentailPeroid) : '';
      }
      if (data.otherLicense2Expiry) {
        data.otherLicense2Range[0] = data.otherLicense2Date; // ? new Date(data.otherCredentailDate) : '';
        data.otherLicense2Range[1] = data.otherLicense2Expiry; // ? new Date(data.otherCredentailPeroid) : '';
      }
    },
    getLabelList() {
      return new Promise((resolve) => {
        supplier.goodsLabelList({
          status: 1,
        }).then((res) => {
          if (res.data.status === 200 && res.data.data.list) {
            const { list } = res.data.data;
            list.forEach((item) => {
              const categoryIds = item.categoryIds.split(',');
              const goodsTypeIds = item.goodsTypeIds.split(',');
              if (categoryIds.includes('2') && (goodsTypeIds.includes('1') || goodsTypeIds.includes('3'))) {
                this.scopeLists.drugBizLabelList.push(item);
              }
              if (categoryIds.includes('3') && (goodsTypeIds.includes('1') || goodsTypeIds.includes('3'))) {
                this.scopeLists.drugProdLabelList.push(item);
              }
              if (categoryIds.includes('2') && goodsTypeIds.includes('2')) {
                this.scopeLists.equipmentBizLabelList.push(item);
              }
              if (categoryIds.includes('3') && goodsTypeIds.includes('2')) {
                this.scopeLists.equipmentProdLabelList.push(item);
              }
            });
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    init() {
      const routeName = this.$route.name;
      let Promises = [];
      if (routeName === 'supplierStoreAdd') {
        Promises = [this.getLabelList()];
      } else if (routeName === 'supplierStoreCheck') {
        Promises = [this.getLabelList(), this.getTitleInfo(), this.getInfos(true)];
      } else {
        Promises = [this.getLabelList(), this.getTitleInfo(), this.getInfos()];
      }
      Promise.all(Promises).then(() => {
        this.able = !(routeName === 'supplierStoreCheck');
        this.baseSupplierShow = true;
        this.$nextTick(() => {
          this.$refs.supplierInfo.handleRoute();
        });
      });
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   const able = !(to.name === 'supplierStoreCheck');
  //   if (from.name === 'supplierStoreAdd') {
  //     next((vm) => {
  //       Promise.all([vm.getLabelList(), vm.getTitleInfo(), vm.getInfos(true)]).then(() => {
  //         vm.able = able;
  //         vm.baseSupplierShow = true;
  //         // 组件内是如果没有绑定路由，没有办法去走到路由守卫，因此在add跳转到edit没有办法监听，需要在调用页面去触发
  //         vm.$nextTick(() => {
  //           vm.$refs.supplierInfo.handleRoute();
  //         });
  //       });
  //     });
  //   } else if (to.name === 'supplierStoreAdd') {
  //     next((vm) => {
  //       vm.getLabelList().then(() => {
  //         vm.able = able;
  //         vm.baseSupplierShow = true;
  //         vm.$nextTick(() => {
  //           vm.$refs.supplierInfo.handleRoute();
  //         });
  //       });
  //     });
  //   } else {
  //     next((vm) => {
  //       Promise.all([vm.getLabelList(), vm.getTitleInfo(), vm.getInfos()]).then(() => {
  //         vm.able = able;
  //         vm.baseSupplierShow = true;
  //         vm.$nextTick(() => {
  //           vm.$refs.supplierInfo.handleRoute();
  //         });
  //       });
  //     });
  //   }
  // },
  created() {
  },
  mounted() {
    if (this.$route.name === 'supplierStoreCheck' && this.permissionFunc('SupplierStorePrint')) {
      this.printText = '打印';
    }
    this.init();
  },
};
</script>
<style lang="less" scoped>
.cardContainer{
  margin-bottom: 12px
}
.steps-wrap{
  padding-top: 30px;
  padding-bottom: 30px;
}
</style>
